import { render, staticRenderFns } from "./assignList.vue?vue&type=template&id=6fccce07&scoped=true&"
import script from "./assignList.vue?vue&type=script&lang=js&"
export * from "./assignList.vue?vue&type=script&lang=js&"
import style0 from "./assignList.vue?vue&type=style&index=0&id=6fccce07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccce07",
  null
  
)

export default component.exports